<template>
  <!-- PREVIOUS MEETINGS -->
  <div class="szw-widget-base-banner__spaced__column">
    <!-- SKELETON -->
    <previous-matches-banner-skeleton v-if="status === 'loading'" />

    <template v-if="status === 'success'">
      <div class="szw-row__center szw-items-center szw-max-w-67 szw-w-full">
        <span class="szw-font-semibold szw-text-xs">{{ props.label }}</span>
      </div>

      <div class="szw-row__between szw-max-w-67 szw-w-full">
        <span class="szw-uppercase szw-font-semibold">{{ props.homeWins.value }}</span>
        <span v-if="sportType !== 'basketball'" class="szw-uppercase szw-font-semibold">{{ props.draws.value }}</span>
        <span class="szw-uppercase szw-font-semibold">{{ props.awayWins.value }}</span>
      </div>

      <div class="szw-row__between szw-gap-0.5 szw-max-w-67 szw-w-full">
        <span class="szw-flex szw-flex-1 szw-h-1 szw-bg-team-home" />
        <span v-if="sportType !== 'basketball'" class="szw-flex szw-flex-1 szw-h-1 szw-bg-yellow" />
        <span class="szw-flex szw-flex-1 szw-h-1 szw-bg-team-away" />
      </div>

      <div class="szw-row__between szw-max-w-67 szw-w-full">
        <span class="szw-font-regular szw-text-xs">{{ props.homeWins.label }}</span>
        <span v-if="sportType !== 'basketball'" class="szw-font-regular szw-text-xs">{{ props.draws.label }}</span>
        <span class="szw-font-regular szw-text-xs">{{ props.awayWins.label }}</span>
      </div>
    </template>
  </div>
</template>

<script setup>
import PreviousMatchesBannerSkeleton from './skeletons/PreviousMatchesBannerSkeleton.vue'
import { inject } from 'vue'

const props = defineProps({
  label: {
    type: String,
    default: () => 'Previous Meetings'
  },
  homeWins: {
    type: Object,
    default: () => ({
      label: '',
      value: 0
    })
  },
  awayWins: {
    type: Object,
    default: () => ({
      label: '',
      value: 0
    })
  },
  draws: {
    type: Object,
    default: () => ({
      label: '',
      value: 0
    })
  },
  sportType: {
    type: String,
    default: () => 'football'
  }
})

const status = inject('status')
</script>
